import { Component, inject } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faEdit, faPlus, faTrashAlt, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BreadcrumbService } from 'xng-breadcrumb';
import { IconsService } from 'src/app/shared/services/icons.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { Settlement } from 'src/app/models/settlement.model';
import { Order } from 'src/app/models/order.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-orders',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tanques [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-3">
            <div class="d-flex mb-0">
              <div class="flex-fill ms-2">
                <h2 class="mt-2 mt-md-0 mb-0">Pedidos</h2>
                <p class="text-muted" style="font-size: 14px;">Agrega pedidos asociados al condominio.</p>
              </div>
            </div>
          </div>
          <div class="list-group-item table-responsive py-3">
            <div class="d-flex">
              <div class="flex-fill ms-3 me-3">
                <div class="input-group mb-0">
                  <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." [formControl]="search">
                  <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                    <fa-icon [icon]="icons.faSearch" *ngIf="!search.value" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                    <fa-icon [icon]="icons.faTimes" *ngIf="search.value" (click)="clearSearch()" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                  </div>
                </div>
              </div>
              <div>
                <select class="form-select border-secondary rounded-3 bg-transparent" (change)="selectSettlement($event)">
                  <option selected [selected]="true" [value]="0">Condominio</option>
                  <option *ngFor="let settlement of settlements" [value]="settlement.id" >{{settlement.name}}</option>
                </select>
              </div>
              <div class="text-end">
                <button class="btn btn-zazz-dark ms-2 shadow-sm" *ngIf="authService.hasPermission('can_create_purchase_orders')" routerLink="create">
                  <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                  Agregar pedido
                </button>
              </div>
            </div>
          </div>
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">#Orden</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Tanque</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Lts. Solicitados</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Precio Lt.</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Condominio</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Estatus</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Creación</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Entrega</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody *ngIf="orders.length>0">
                <tr app-tr-order
                  [order]="order"
                  [profile]="profile" 
                  [permissions]="permissions"
                  (refreshOrders)="loadOrders(this.payload)"
                  *ngFor="let order of orders | paginate: { 
                    itemsPerPage: payload.per_page, 
                    currentPage: p, 
                    totalItems: meta.total_entries 
                  }"
                >
                </tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="orders.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="orders.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class OrdersComponent {
  loading: boolean = false;
  orders: Order[] = [];
  settlements: Settlement[] = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};

  currentView: string = 'orders';
  search: FormControl = new FormControl();

  payload: any = {
    page: 1,
    per_page: 30,
  };

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile ? this.profile.id : 0;
  }
  

  ngOnInit(): void {
    this.loadOrders(this.payload);
    this.loadSettlements();

    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (!term) {
          return this.store.getPurchaseOrders({
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          });
        } else {
          return this.store.getPurchaseOrders({
            folio: term, 
            profile_id: this.payload.profile_id,
            page: 1,
            per_page: this.payload.per_page
          })
        }
      })).subscribe((data: any) => {
        this.orders = data.data;
        this.meta = data.meta;
      });
  }

  loadOrders(payload: any) {
    this.loading = true;
    this.store.getPurchaseOrders(payload).subscribe({
      next: (orders: any) => {
        this.orders = orders.data;
        this.meta = orders.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err.status);
        this.loading = false;
        this.orders = [];
        if (err.status === 500) {
          this.toastr.error('Ocurrió un error al obtener las amenidades.', 'Error');
        }
      }
    });
  }

  loadSettlements() {
    let settlementPayload: any = {
      page: 1,
      per_page: 300,
      utility_id: this.profile.utility_id
    };
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      this.settlements = data.data;
    });
  }

  selectSettlement(event: any) {
    if (event.target.value == 0) {
      delete this.payload.settlement_id;
    } else {
      this.payload.settlement_id = event.target.value;
    }
    this.loadOrders(this.payload);
  }

  clearSearch() {
    delete this.payload.folio;
    this.search.setValue(null);    
    this.loadOrders(this.payload);
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadOrders(this.payload);
  }
}
